import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../components/Headers/Header";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { Horse } from "../../../../models";
import { getAllHorses, getAllHorsesWithBasicFields, getHorsesByContainsNameFilter, getHorsesByNameGSI, getSegmentOfHorses } from "../../../../utilities/horse/Horse";
import Spinner from "../../../../components/Spinners/Spinner";
import SelectHorseSection from "../../../../components/Entry/EntryForm/SelectHorseSection";

const AdminHorsePage: React.FC = () => {

    // State for testing current way of getting all horses. 
    const [isLoadingOne, setIsLoadingOne] = useState(false);
    const [loadTimeOne, setLoadTimeOne] = useState(0);
    const [allHorsesOne, setAllHorsesOne] = useState<Horse[] | null | undefined>();

    // State for testing getting all horses via old function with a specific limit - 100
    const [isLoadingTwo, setIsLoadingTwo] = useState(false);
    const [loadTimeTwo, setLoadTimeTwo] = useState(0);
    const [allHorsesTwo, setAllHorsesTwo] = useState<Horse[] | null | undefined>();

    // State for testing getting all horses via old function with a specific limit - 1000
    const [isLoadingThree, setIsLoadingThree] = useState(false);
    const [loadTimeThree, setLoadTimeThree] = useState(0);
    const [allHorsesThree, setAllHorsesThree] = useState<Horse[] | null | undefined>();

    // State for testing getting all horses with only basic fields - limit - 1000
    const [isLoadingFour, setIsLoadingFour] = useState(false);
    const [loadTimeFour, setLoadTimeFour] = useState(0);
    const [allHorsesFour, setAllHorsesFour] = useState<Horse[] | null | undefined>();

    // State for testing getting all horses with all fields - segment size = 20
    const [isLoadingFive, setIsLoadingFive] = useState(false);
    const [loadTimeFive, setLoadTimeFive] = useState(0);
    const [allHorsesFive, setAllHorsesFive] = useState<Horse[] | null | undefined>();

    // State for testing getting all horses with only basic fields - segment size = 20
    const [isLoadingSix, setIsLoadingSix] = useState(false);
    const [loadTimeSix, setLoadTimeSix] = useState(0);
    const [allHorsesSix, setAllHorsesSix] = useState<Horse[] | null | undefined>();

    // State for testing getting horses by name using just a filter to find horses where their name contains "Test" - limit 1000 at a time
    const [isLoadingSeven, setIsLoadingSeven] = useState(false);
    const [loadTimeSeven, setLoadTimeSeven] = useState(0);
    const [allHorsesSeven, setAllHorsesSeven] = useState<Horse[] | null | undefined>();

    // State for testing getting horses by name using a GSI to find horses where their name is exactly "Test" - limit 1000 at a time
    const [isLoadingEight, setIsLoadingEight] = useState(false);
    const [loadTimeEight, setLoadTimeEight] = useState(0);
    const [allHorsesEight, setAllHorsesEight] = useState<Horse[] | null | undefined>();

    // State for testing getting horses by name using a GSI to find horses where their name is exactly "Test" with only basic details - limit 1000 at a time
    const [isLoadingNine, setIsLoadingNine] = useState(false);
    const [loadTimeNine, setLoadTimeNine] = useState(0);
    const [allHorsesNine, setAllHorsesNine] = useState<Horse[] | null | undefined>();

    useEffect(() => {
        const getAllHorsesOne = async () => {
            setIsLoadingOne(true);
            const startTime = performance.now();
            const queryResult = await getAllHorses();
            if (queryResult.isSuccess) {
                const allHorsesWithAllFields = queryResult.result;
                setAllHorsesOne(allHorsesWithAllFields);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeOne(executionTime)
            setIsLoadingOne(false);
        }
        if (!allHorsesOne) getAllHorsesOne();

        const getAllHorsesTwo = async () => {
            setIsLoadingTwo(true);
            const startTime = performance.now();
            const queryResult = await getAllHorses(100);
            if (queryResult.isSuccess) {
                const allHorsesWithAllFields = queryResult.result;
                setAllHorsesTwo(allHorsesWithAllFields);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeTwo(executionTime)
            setIsLoadingTwo(false);
        }
        if (!allHorsesTwo) getAllHorsesTwo();

        const getAllHorsesThree = async () => {
            setIsLoadingThree(true);
            const startTime = performance.now();
            const queryResult = await getAllHorses(1000);
            if (queryResult.isSuccess) {
                const allHorsesWithAllFields = queryResult.result;
                setAllHorsesThree(allHorsesWithAllFields);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeThree(executionTime)
            setIsLoadingThree(false);
        }
        if (!allHorsesThree) getAllHorsesThree();

        const getAllHorsesFour = async () => {
            setIsLoadingFour(true);
            const startTime = performance.now();
            const queryResult = await getAllHorsesWithBasicFields(1000);
            if (queryResult.isSuccess) {
                const allHorsesWithBasicFields = queryResult.result;
                setAllHorsesFour(allHorsesWithBasicFields);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeFour(executionTime)
            setIsLoadingFour(false);
        }
        if (!allHorsesFour) getAllHorsesFour();

        const getAllHorsesFive = async () => {
            setIsLoadingFive(true);
            const startTime = performance.now();
            const queryResult = await getSegmentOfHorses(20);
            if (queryResult.isSuccess) {
                const segmentOfHorses = queryResult.result.items;
                setAllHorsesFive(segmentOfHorses);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeFive(executionTime)
            setIsLoadingFive(false);
        }
        if (!allHorsesFive) getAllHorsesFive();

        const getAllHorsesSix = async () => {
            setIsLoadingSix(true);
            const startTime = performance.now();
            const queryResult = await getSegmentOfHorses(20, undefined, true);
            if (queryResult.isSuccess) {
                const segmentOfHorses = queryResult.result.items;
                setAllHorsesSix(segmentOfHorses);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeSix(executionTime)
            setIsLoadingSix(false);
        }
        if (!allHorsesSix) getAllHorsesSix();

        const getAllHorsesSeven = async () => {
            setIsLoadingSeven(true);
            const startTime = performance.now();
            const queryResult = await getHorsesByContainsNameFilter("Test");
            if (queryResult.isSuccess) {
                const horsesThatMatchNameFilter = queryResult.result;
                setAllHorsesSeven(horsesThatMatchNameFilter);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeSeven(executionTime)
            setIsLoadingSeven(false);
        }
        if (!allHorsesSeven) getAllHorsesSeven();

        const getAllHorsesEight = async () => {
            setIsLoadingEight(true);
            const startTime = performance.now();
            const queryResult = await getHorsesByNameGSI("Test Horse");
            if (queryResult.isSuccess) {
                const horsesThatMatchName = queryResult.result;
                setAllHorsesEight(horsesThatMatchName);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeEight(executionTime)
            setIsLoadingEight(false);
        }
        if (!allHorsesEight) getAllHorsesEight();

        const getAllHorsesNine = async () => {
            setIsLoadingNine(true);
            const startTime = performance.now();
            const queryResult = await getHorsesByNameGSI("Test Horse", true);
            if (queryResult.isSuccess) {
                const horsesThatMatchName = queryResult.result;
                setAllHorsesNine(horsesThatMatchName);
            }
            const endTime = performance.now();
            const executionTime = endTime - startTime;
            setLoadTimeNine(executionTime)
            setIsLoadingNine(false);
        }
        if (!allHorsesNine) getAllHorsesNine();
    }, []);

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="RSP Horses" />
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>All Horses</IonCardTitle>
                            <IonCardContent>
                                {/* Row 1 = standard */}
                                <IonRow>
                                    <IonCol>
                                        <h2>1: Load all horses in the DB with all of their fields using the already existing way (to use as a standard to compare the other approaches to.)</h2>
                                        {isLoadingOne ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesOne?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeOne.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeOne/1000).toFixed(3)} seconds</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 2 = limit of 100 */}
                                <IonRow>
                                    <IonCol>
                                        <h2>2: Load all horses in the DB with all of their fields using the already existing way - set limit of 100</h2>
                                        {isLoadingTwo ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesTwo?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeTwo.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeTwo/1000).toFixed(3)} seconds</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 3 = limit of 1000 */}
                                <IonRow>
                                    <IonCol>
                                        <h2>3: Load all horses in the DB with all of their fields using the already existing way - set limit of 1000</h2>
                                        {isLoadingThree ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesThree?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeThree.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeThree/1000).toFixed(3)} seconds</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 4 = Basic Fields limit of 1000 */}
                                <IonRow>
                                    <IonCol>
                                        <h2>4: Load all horses in the DB with only basic fields (Projection) - set limit of 1000</h2>
                                        {isLoadingFour ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesFour?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeFour.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeFour/1000).toFixed(3)} seconds = {(loadTimeFour/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 5 = Segmentation - All Fields */}
                                <IonRow>
                                    <IonCol>
                                        <h2>5: Load only 20 horses in the DB with all of their fields (Segmentation) - segment size = 20</h2>
                                        {isLoadingFive ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesFive?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeFive.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeFive/1000).toFixed(3)} seconds = {(loadTimeFive/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 6 = Segmentation + Projection */}
                                <IonRow>
                                    <IonCol>
                                        <h2>6: Load only 20 horses in the DB with only basic fields fields (Segmentation + Projection) - segment size = 20</h2>
                                        {isLoadingSix ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesSix?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeSix.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeSix/1000).toFixed(3)} seconds = {(loadTimeSix/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 7 = Filter - basic filter on the server-side */}
                                <IonRow>
                                    <IonCol>
                                        <h2>7: Filter horses in the DB whose name contains "Test" (Server-Side Filter) - limit of 1000</h2>
                                        {isLoadingSeven ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesSeven?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeSeven.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeSeven/1000).toFixed(3)} seconds = {(loadTimeSeven/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 8 = Filter - GSI on the server side */}
                                <IonRow>
                                    <IonCol>
                                        <h2>8: Filter horses in the DB that match the name "Test Horse" (Server-Side Filter with GSI) - limit of 1000</h2>
                                        {isLoadingEight ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesEight?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeEight.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeEight/1000).toFixed(3)} seconds = {(loadTimeEight/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                {/* Row 9 = Filter - GSI on the server side + Projection */}
                                <IonRow>
                                    <IonCol>
                                        <h2>9: Filter horses in the DB that match the name "Test Horse" and only get basic details (Server-Side Filter with GSI + Projection) - limit of 1000</h2>
                                        {isLoadingNine ?
                                            <Spinner />
                                            :
                                            <>
                                                <p>Total Horses: {allHorsesNine?.length}</p>
                                                <p>Done Loading in: </p>
                                                <p>{loadTimeNine.toFixed(3)} milliseconds</p>
                                                <p>{(loadTimeNine/1000).toFixed(3)} seconds = {(loadTimeNine/loadTimeOne*100).toFixed(0)}% of Option 1</p>
                                            </>
                                        }
                                    </IonCol>
                                </IonRow>
                                
                                <SelectHorseSection />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default AdminHorsePage;